import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function XCloseIcon({ className, title }) {
    return (_jsxs("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", children: [title && _jsx("title", { children: title }), _jsx("path", { d: "M18 6L6 18M6 6L18 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}
//# sourceMappingURL=XCloseIcon.js.map